namespace h5_vm {

   import IQService = angular.IQService;
   import VmProvisioningPageService = h5_vm.VmProvisioningPageService;
   import VmProvisioningPage = h5_vm.VmProvisioningPageModel;
   import VmProvisioningWizardPage = h5_vm.VmProvisioningWizardPage;

   export class VmProvisioningCustomizeTemplatePageService implements VmProvisioningPageService {

      static $inject: string[] = [
         "i18nService",
         "vuiConstants",
         "vmVuiWizardPageBuilder",
         "vmProvisioningCustomizeTemplatePageModel"
      ];

      constructor(
         private i18nService: any,
         private vuiConstants: any,
         private vmVuiWizardPageBuilder: any,
         private vmProvisioningCustomizeTemplatePageModel: any) { }

      public build(wizardScope: any): VmProvisioningWizardPage {
         let pageModel = new this.vmProvisioningCustomizeTemplatePageModel(
               wizardScope.vmParams,
               wizardScope.wizardViewData);

         wizardScope.vmProvisioningCustomizeTemplatePageModel = pageModel;

         return this.vmVuiWizardPageBuilder.buildVuiWizardPage(
            wizardScope.config,
            {
               title: this.i18nService.getString("Common", "UserDefinedPropertiesPage.title"),
               description: this.i18nService.getString("Common", "UserDefinedPropertiesPage.description"),
               contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages" +
                     "/vmProvisioningCustomizeTemplate/vm-provisioning-customize-template.html",
               model: pageModel,
               defaultState: this.vuiConstants.wizard.pageState.SKIPPED
            }
         );
      }
   }

   angular.module("com.vmware.vsphere.client.vm")
      .service("vmProvisioningCustomizeTemplatePageService", VmProvisioningCustomizeTemplatePageService);

}
